import { v4 as uuidv4 } from 'uuid';
const _ = require('lodash');
const Vuedoc = require('@vuedoc/parser')

/**
 * BlockComponent对象，结构如下(兼容xmind格式)
 * {
      "title": "component",
      "note": {},
      "topics": [
        {
          "title": "component",
          "note": {},   // 此处为component-schema
          "topics": []  // 此处为slot内容
        }
      ]
    }
 */
export default class BlockComponent {
  constructor(component) {
    component = component || {};
    this.key = component.key || uuidv4()
    this.component = component
    this.title = component.title
    this.note = {
      events: {
        'click': {
          'value': [{
            type: 'code',
            value: 'function() {}'
          }, {
            type: 'data-interaction', 
            value: '获取用户列表'
          }]
        } 
      }
    }
    this.doc = {}
    this.blockComponents = []
  }

  // 首次初始化的参数
  static async create(component){
    let blockComponent = new BlockComponent(component)
    // 需要同步的属性
    blockComponent.doc = await blockComponent.getDoc()
    blockComponent.note = await blockComponent.getNote(blockComponent.doc)
    return blockComponent
  }

  async getNote(doc) {
    return {
      style: {
        css: ''
      },
      props: await this.initProps(doc),
      directives: this.initDirectives(),
      events: await this.initEvents(doc)
    }
  }

  /**
   * 初始化 this.note.props
   */
  async initProps(doc) {
    let self = this;
    let props = {}
    _.each(JSON.parse(JSON.stringify(doc.props)), prop => {
      prop['value'] = {
        type: 'string',   // 支持两种type类型：string | code
        value: self.getPropDefaultValue(prop)
      }
      props[prop.name] = prop
    })

    return props
  }

  getPropDefaultValue(prop) {
    if (!prop.default) {
      return null;
    }

    if (prop.type === 'Boolean') {
      return prop.default == 'true';
    }
    if (prop.type === 'Number') {
      return Number(prop.default)
    }
    if (prop.type === 'Object') {
      return eval(`(${prop.default})`)();
    }
    if (prop.type === 'Array') {
      return eval(`(${prop.default})`)();
    }
    return prop.default.slice(1, prop.default.length - 1)
  }

  /**
   * 初始化 this.note.directives
   */
  initDirectives() {
    let directives = {}

    let supportedDirectives = [
      'v-if', 'v-show', 'v-model', 'v-html', 'v-for'
    ]

    _.each(supportedDirectives, directive => {
      directives[directive] = {
        type: 'code',   // 支持1种type类型：code
        value: null
      }
    })

    return directives
  }

  /**
   * 初始化 this.note.events
   */
  async initEvents(doc) {
    let events = {}
    _.each(JSON.parse(JSON.stringify(doc.events)), event => {
      event['value'] = []
      events[event['name']] = event
    })

    return events
  }

  /**
   * 在组件的slot内新增component
   * @param {*} afterComponentKey 在某个component后插入component. key为 utils/component.js中的key
   * @param {*} blockComponent 插入的component的对象
   */
  addChildComponent(afterComponentKey, blockComponent) {
    if (!afterComponentKey) {
      this.blockComponents.unshift(blockComponent)
      return;
    }

    let afterIndex = this.getComponentIndex(afterComponentKey)
    return _concat(
      this.blockComponents.slice(0, afterIndex + 1), 
      blockComponent, 
      this.blockComponents.slice(afterIndex + 1, this.blockComponents.length + 1)
    )
  }

  getComponentIndex(componentKey) {
    for(let i = 0; i < this.blockComponents.length; i++) {
      if (componentKey == this.blockComponents[i].key) {
        return i;
      }
    }
    return null;
  }

  /**
   * 在组件的slot中删除component
   * @param {*} componentKey 
   */
  delComponent(componentKey) {
    this.blockComponents = _.reject(this.blockComponents, item => item.key === componentKey)
  }

  /**
   * 检测组件是否存在
   * @param {*} componentKey 
   */
  hasChildComponent(componentKey) {
    return !!_.keyBy(this.blockComponents, 'key')[componentKey]
  }

  async getDoc() {
    if (!this.component.code) {
      return {
        props:[], events:[]
      }
    }

    return await Vuedoc.parse({
      filecontent: this.component.code
    })
  }

  toJSON() {
    return {
      key: this.key,
      title: this.title,
      note: this.note,
      component: this.component,
      doc: this.doc,
      topics: _.map(this.blockComponents, (blockComponent) => blockComponent.toJSON())
    }
  }

  static fromJSON(componentJson) {
    let blockComponent = new BlockComponent(
      _.assign(componentJson.component, {key: componentJson.key}));
    // let blockComponent = new BlockComponent(componentJson);
    blockComponent.note = componentJson.note;
    blockComponent.title = componentJson.title;
    blockComponent.key = componentJson.key;
    blockComponent.doc = componentJson.doc;
    
    _.each(componentJson.topics, topic => {
      let childComponent = new BlockComponent(_.assign(topic.component), {key: topic.key})
      childComponent.note = topic.note
      childComponent.title = topic.title;
      childComponent.key = topic.key;
      childComponent.doc = topic.doc
      // let childComponent = new BlockComponent(topic)
      blockComponent.blockComponents.push(childComponent)
    })

    return blockComponent;
  }
}